import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Domain, DomainsModel } from './../../models/domains.model';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styles: []
})
export class ModalInfoComponent implements OnInit {

  wpVersion: string;
  phpVersion: string;
  tema: string;
  plugins: string;
  observacions: string;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) { }

  ngOnInit() {
  }
}
